
/* BOCHAN cart enhancements: cart/wishlist tabs, free samples, gift card, promo. */
(function () {
  'use strict';
  if (window.__bochanCartEnhancementsLoaded) return;
  window.__bochanCartEnhancementsLoaded = true;

  const routes = window.routes || {};
  const cartUrl = routes.cart_url || '/cart';
  const addUrl = routes.cart_add_url || '/cart/add.js';
  const changeUrl = routes.cart_change_url || '/cart/change.js';
  const updateUrl = routes.cart_update_url || '/cart/update.js';
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  let sampleBusy = false;
  let enforcing = false;
  let enforcementTimer;
  let refreshVersion = 0;
  let refreshChain = Promise.resolve();

  async function requestJson(url, options) {
    const response = await fetch(url, options || { headers });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(data.description || data.message || `Cart request failed (${response.status})`);
      error.status = response.status;
      throw error;
    }
    return data;
  }

  const cartData = () => requestJson('/cart.js', { headers });
  const changeLine = (key, quantity) => requestJson(changeUrl, {
    method: 'POST', headers, body: JSON.stringify({ id: key, quantity })
  });

  function cartStrings(name, fallback) {
    return (window.cartEnhancementsStrings && window.cartEnhancementsStrings[name]) || fallback;
  }

  function parseSection(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceSelector(doc, selector) {
    const current = document.querySelector(selector);
    const incoming = doc.querySelector(selector);
    if (current && incoming) current.replaceWith(incoming);
  }

  async function fetchSection(sectionId) {
    const url = `${cartUrl}${cartUrl.includes('?') ? '&' : '?'}section_id=${encodeURIComponent(sectionId)}`;
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Unable to refresh ${sectionId} (${response.status})`);
    return parseSection(await response.text());
  }

  function syncCartCount() {
    return cartData().then(cart => {
      // Preserve the original theme's cart counter behavior.
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = `(${cart.item_count})`; });
    }).catch(err => console.warn('Cart count sync failed:', err));
  }

  // Serialize our own refreshes. An older response cannot replace a newer request's UI.
  function refreshCartUI() {
    const version = ++refreshVersion;
    const work = async () => {
      if (version !== refreshVersion) return;
      const hasDrawer = !!document.querySelector('cart-drawer');
      const items = document.getElementById('main-cart-items');
      const footer = document.getElementById('main-cart-footer');
      const hasBubble = !!document.getElementById('cart-icon-bubble');
      const tasks = [];
      if (hasDrawer) tasks.push(fetchSection('cart-drawer').then(doc => ({ kind: 'drawer', doc })));
      if (items && items.dataset.id) tasks.push(fetchSection(items.dataset.id).then(doc => ({ kind: 'items', doc })));
      if (footer && footer.dataset.id) tasks.push(fetchSection(footer.dataset.id).then(doc => ({ kind: 'footer', doc })));
      if (hasBubble) tasks.push(fetchSection('cart-icon-bubble').then(doc => ({ kind: 'bubble', doc })));
      const results = await Promise.all(tasks);
      if (version !== refreshVersion) return;
      results.forEach(({ kind, doc }) => {
        if (kind === 'drawer') {
          replaceSelector(doc, 'cart-drawer-items');
          replaceSelector(doc, 'cart-drawer .drawer__footer');
        } else if (kind === 'items' || kind === 'footer') {
          const root = document.getElementById(kind === 'items' ? 'main-cart-items' : 'main-cart-footer');
          const source = doc.querySelector('.js-contents');
          const target = root && root.querySelector('.js-contents');
          if (source && target) target.innerHTML = source.innerHTML;
        } else if (kind === 'bubble') {
          const bubble = document.getElementById('cart-icon-bubble');
          const source = doc.getElementById('cart-icon-bubble');
          if (bubble && source) bubble.innerHTML = source.innerHTML;
        }
      });
      await syncCartCount();
    };
    refreshChain = refreshChain.catch(() => {}).then(work);
    return refreshChain;
  }

  function sampleMessage(checkbox, message) {
    const root = checkbox && checkbox.closest('[data-cart-samples]');
    const target = root && root.querySelector('[data-samples-message]');
    if (target) target.textContent = message || '';
  }

  function lockSampleInputs(locked) {
    document.querySelectorAll('[data-sample-checkbox]').forEach(input => {
      if (locked) {
        input.dataset.previouslyDisabled = input.disabled ? 'true' : 'false';
        input.disabled = true;
      } else {
        input.disabled = input.dataset.previouslyDisabled === 'true';
        delete input.dataset.previouslyDisabled;
      }
    });
  }

  function currentSampleLimit() {
    const list = document.querySelector('[data-samples-limit]');
    return list ? Math.max(0, parseInt(list.dataset.samplesLimit || '0', 10) || 0) : null;
  }

  async function enforceSampleLimit() {
    if (sampleBusy || enforcing) return;
    const limit = currentSampleLimit();
    if (limit === null) return;
    enforcing = true;
    try {
      const cart = await cartData();
      const samples = cart.items.filter(item => item.properties && item.properties._sample);
      let excess = samples.reduce((total, item) => total + item.quantity, 0) - limit;
      if (excess <= 0) return;
      // Trim from the last selected sample first; retain the earlier choices.
      for (const item of samples.slice().reverse()) {
        if (excess <= 0) break;
        const remove = Math.min(excess, item.quantity);
        await changeLine(item.key, item.quantity - remove);
        excess -= remove;
      }
      await refreshCartUI();
    } catch (err) {
      console.error('Unable to enforce free sample limit:', err);
    } finally {
      enforcing = false;
    }
  }

  function scheduleSampleEnforcement() {
    clearTimeout(enforcementTimer);
    enforcementTimer = setTimeout(() => { enforceSampleLimit(); }, 650);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      syncCartCount();
      scheduleSampleEnforcement();
    });
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest('.cart-tabs__tab');
    if (!tab) return;
    const root = tab.closest('.cart-tabs');
    const drawer = tab.closest('cart-drawer') || document;
    const targetId = tab.getAttribute('data-tab-target');
    if (root) root.querySelectorAll('.cart-tabs__tab').forEach(el => {
      el.setAttribute('aria-selected', el === tab ? 'true' : 'false');
    });
    drawer.querySelectorAll('.cart-tab-panel').forEach(panel => {
      panel.hidden = panel.id !== targetId;
    });
    const empty = drawer.querySelector('.drawer__inner-empty');
    if (empty) empty.style.display = targetId === 'CartDrawer-CartPanel' ? '' : 'none';
  });

  document.addEventListener('change', async event => {
    const checkbox = event.target.closest('[data-sample-checkbox]');
    if (!checkbox) return;
    if (sampleBusy || enforcing) return;
    const variantId = checkbox.value;
    const shouldAdd = checkbox.checked;
    sampleBusy = true;
    sampleMessage(checkbox, '');
    lockSampleInputs(true);
    try {
      if (!variantId) throw new Error(cartStrings('sampleUnavailable', 'This sample is unavailable.'));
      const cart = await cartData();
      const samples = cart.items.filter(item => item.properties && item.properties._sample);
      const chosen = samples.find(item => String(item.variant_id) === String(variantId));
      if (shouldAdd) {
        const limit = currentSampleLimit() || 0;
        const count = samples.reduce((sum, item) => sum + item.quantity, 0);
        if (count >= limit) throw new Error('You have reached your free sample limit.');
        if (!chosen) {
          await requestJson(addUrl, {
            method: 'POST', headers,
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _sample: 'true' } }] })
          });
        }
      } else if (chosen) {
        await changeLine(chosen.key, 0);
      }
      await refreshCartUI();
    } catch (err) {
      checkbox.checked = !shouldAdd;
      sampleMessage(checkbox, err.message || cartStrings('sampleUnavailable', 'This sample could not be updated.'));
      console.error('Sample update failed:', err);
    } finally {
      sampleBusy = false;
      lockSampleInputs(false);
      scheduleSampleEnforcement();
    }
  });

  function setDiscountMessage(scope, message, state) {
    const target = scope && scope.querySelector('[data-discount-message]');
    if (!target) return;
    target.textContent = message || '';
    target.classList.remove('is-error', 'is-success');
    if (state) target.classList.add(state);
  }

  async function applyGiftCard(button) {
    if (button.disabled) return;
    const wrap = button.closest('[data-cart-discount]');
    const input = wrap && wrap.querySelector('[data-gift-card-input]');
    if (!input) return;
    const code = input.value.trim();
    button.disabled = true;
    try {
      await requestJson(updateUrl, {
        method: 'POST', headers, body: JSON.stringify({ attributes: { 'Gift Card': code } })
      });
      await refreshCartUI();
      const current = document.querySelector('[data-cart-discount]');
      setDiscountMessage(current, code ? cartStrings('giftSaved', 'Gift card saved — applied at checkout.') : '', code ? 'is-success' : null);
    } catch (err) {
      setDiscountMessage(wrap, cartStrings('error', err.message || 'Something went wrong.'), 'is-error');
    } finally {
      button.disabled = false;
    }
  }

  async function applyPromo(button) {
    if (button.disabled) return;
    const wrap = button.closest('[data-cart-discount]');
    const input = wrap && input.value.trim();
    if (!code) return;
    button.disabled = true;
    try {
      const response = await fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' });
      if (!response.ok) throw new Error(`Discount request failed (${response.status})`);
      const cart = await cartData();
      const applied = (cart.cart_level_discount_applications || []).some(discount =>
        (discount.title || '').toUpperCase() === code.toUpperCase()
      );
      await refreshCartUI();
      const current = document.querySelector('[data-cart-discount]');
      const nextInput = current && current.querySelector('[data-promo-input]');
      if (applied && nextInput) nextInput.value = '';
      setDiscountMessage(current,
        applied ? cartStrings('promoApplied', 'Promo code applied.') : cartStrings('promoInvalid', 'This code is not valid.'),
        applied ? 'is-success' : 'is-error');
    } catch (err) {
      setDiscountMessage(wrap, cartStrings('error', err.message || 'Something went wrong.'), 'is-error');
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', event => {
    const gift = event.target.closest('[data-gift-card-submit]');
    if (gift) { event.preventDefault(); applyGiftCard(gift); return; }
    const promo = event.target.closest('[data-promo-submit]');
    if (promo) { event.preventDefault(); applyPromo(promo); }
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    if (event.target.matches('[data-promo-input]')) {
      event.preventDefault();
      const button = event.target.closest('[data-cart-discount]')?.querySelector('[data-promo-submit]');
      if (button) applyPromo(button);
    } else if (event.target.matches('[data-gift-card-input]')) {
      event.preventDefault();
      const button = event.target.closest('[data-cart-discount]')?.querySelector('[data-gift-card-submit]');
      if (button) applyGiftCard(button);
    }
  });
})();
